

function sanatiseFormData(formData){
  for (let [key, value] of formData.entries()) {
     if (value === '' || key.startsWith("updates")){
       formData.delete(key);
     } 
  }
  return formData
}

function proceedToCheckout(){
    document.querySelectorAll('.cart__checkout-button').forEach(button => button.classList.remove("present-form"));

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: sanatiseFormData(new FormData(document.querySelector("#cart")))
    })
    .then(response => document.querySelector('.cart__checkout-button').click())
}

function isVisible(elem) {
  return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length )
}

function formCheck(){
    //find select
    var selectValue = document.getElementById('medical-condition').value;
    //find inputs
    var noVatRelief =  document.getElementById('do-not-qualify-for-vat-relief').checked;
    var charity =  document.getElementById('declarationCheckbox').checked;

    if((selectValue != '' && !noVatRelief && !charity)
      || (selectValue == '' && noVatRelief && !charity)
      || (selectValue == '' && !noVatRelief && charity)){
      //if one is filled, proceed
      proceedToCheckout()
    }else if(isVisible(document.querySelector('.caf-wrap'))){
      //if form is already open, error message
      document.querySelector('.form-error-2').style.display="none";
      document.querySelector('.form-error').style.display="block";
      document.querySelector('.form-error-3').style.display="none";
    }else{
      //else open popup
      document.querySelector('.caf-wrap').style.display="block";
      document.querySelector(".section-header").style["z-index"]=-1;
    }
}


document.querySelectorAll("button.present-form").forEach(button => {
  button.addEventListener('click', event => {
    if(button.classList.contains('present-form')){
    event.stopImmediatePropagation();
     event.preventDefault();
     formCheck()
    }
  });
});

document.querySelectorAll('.cart-form-submit').forEach(checkoutButton => {
  checkoutButton.addEventListener('click', event => {
    if(document.getElementById('do-not-qualify-for-vat-relief').checked && document.getElementById('medical-condition').value == "" 
      && !document.getElementById('declarationCheckbox').checked){
      updateVatFreeProducts();
    }else{
      formCheck()
    }
  })
})


document.querySelector(".closeModalWindow").addEventListener('click', event => {
  document.querySelector(".caf-wrap").style.display="none";
      document.querySelector(".section-header").style["z-index"]=3;
})


document.querySelector(".cancel-button").addEventListener('click', event => {
  document.querySelector(".caf-wrap").style.display="none";
      document.querySelector(".section-header").style["z-index"]=3;
})
